//// Profile for company user
import React, { useEffect, useState, useRef } from "react";
import "./profile.scss";
import CancelSaveHeader from "../../components/customPageHeader/CancelSaveHeader";
import { useAuth } from "../../contexts/auth";
import defaultProfilePic from "../../assets/profilepic.jpg";
import "../../components/typographyText/styles.scss";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import CustomChangePwdPopup from "../../components/customPopup/CustomChangePwdPopup";
import { Button, LoadPanel, TextBox } from "devextreme-react";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { generateOtpWithAction } from "../../api/forgotPwdApi";
import { editCmpUserApi, getUserByCodeApi } from "../../api/companyUserApi";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const projectSectionRef = useRef(null);
  const [isProflePopupVisible, setisProflePopupVisible] = useState(false);
  const { user, setUser } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const [image, setImage] = useState();
  const [dispimage, setDispImage] = useState();
  const [loading, setLoading] = useState(false);
  const [cmpUserData, setCmpUserData] = useState({});
  const [userPhno, setUserPhno] = useState();
  const [errors, setErrors] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [contactNumber, setContactNumber] = useState("");
  const [assignedProjects, setAssignedProjects] = useState([]);
  
  useEffect(() => {
    if (cmpUserData?.cmpusercontactnumber) {
      setContactNumber(cmpUserData.cmpusercontactnumber);
    }
  }, [cmpUserData]);

  useEffect(() => {
    if (location.state?.section === "projects") {
      setTimeout(() => {
        projectSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        projectSectionRef.current?.classList.add("highlight");

        setTimeout(() => {
          projectSectionRef.current?.classList.remove("highlight");
        }, 2000);
      }, 300);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchUser = async () => {
      if (user) {
        try {
          setLoading(true);
          const result = await getUserByCodeApi(
            user?.cmpusercode,
            user?.access_token,
          );
          if (result.status === 200 ) {
            setCmpUserData({
              ...result.data.data,
              categories: result.data.categories, //  ADD THIS
            });
            // setCmpUserData(result.data.data);
            setUserPhno(result.data.data.cmpusercontactnumber);
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error.response?.data?.error || "An unexpected error occurred.",
          );
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    if (cmpUserData && cmpUserData.project_details && cmpUserData.categories) {
      const mapped = cmpUserData.categories
        .map((cat) => {
          const subcategories = cat.subcategories
            .map((sub) => {
              const match = cmpUserData.project_details.find(
                (p) => p.transid === sub.subcategory_id,
              );
              return match;
            })
            .filter(Boolean); // remove nulls

          return {
            category_name: cat.category_name,
            subcategories,
          };
        })
        .filter((cat) => cat.subcategories.length > 0); // only show assigned

      setAssignedProjects(mapped);
    }
  }, [cmpUserData]);

  const handleImageClick = (e) => {
    e.preventDefault();
    document.getElementById("profileImage").click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setImage(reader.result);
        setDispImage(reader.result.split(",")[1]);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageHover = (isHovering) => {
    setIsHovered(isHovering);
  };

  const handleProfileSaveDetails = async () => {
    const value = contactNumber?.trim(); //  use correct state

    const errors = {};
    if (!/^\d{3,15}$/.test(value)) {
      errors.cmpusercontactnumber =
        value === ""
          ? "Contact Number is Required."
          : /^\d*$/.test(value)
            ? "Contact Number should be 3 to 15 digits only."
            : "Only numbers are allowed.";

      Object.values(errors).forEach((error) => ToastDisplayer("error", error));
      setErrors(errors);
      return;
    }

    try {
      setLoading(true);
      var myformdata;
      if (dispimage !== undefined) {
        myformdata = { cmpusercontactnumber: value, userlogo: dispimage };
      } else {
        myformdata = { cmpusercontactnumber: value };
      }

      const result = await editCmpUserApi(cmpUserData.cmpusercode, myformdata);

      if (result.status === 200 ) {
        if (dispimage != undefined) {
          setUser((prevUser) => ({
            ...prevUser,
            userlogo: dispimage,
          }));
          const getSess = JSON.parse(sessionStorage.getItem("authState")) || {};
          const updSess = { ...getSess, userlogo: dispimage };
          sessionStorage.setItem("authState", JSON.stringify(updSess));
        }
        ToastDisplayer("success", result.data.message);
        // navigate("/");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.statusText || "An error occurred",
      );
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileOtpPopup = async () => {
    try {
      setLoading(true);
      const otpResult = await generateOtpWithAction(user.email, "R");
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );

      setisProflePopupVisible(!isProflePopupVisible);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileCloseFromPopup = async () => {
    setisProflePopupVisible(!isProflePopupVisible);
  };

  useEffect(() => {
    if (user?.userlogo) {
      setImage(`data:image/jpeg;base64,${user?.userlogo}`);
    } else {
      setImage("");
    }
  }, [user]);

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="ProfilePage">
        <CancelSaveHeader
          titleName={"Developer Profile"}
          handleDetCancel={handleCancel}
          handleDetSave={handleProfileSaveDetails}
        />

        <div className="profileMain">
          <div className="mainProfileSection">
            <div className="profileUpper">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div
                  className={`user-image-container ${isHovered ? "hovered" : ""}`}
                  onMouseEnter={() => handleImageHover(true)}
                  onMouseLeave={() => handleImageHover(false)}
                >
                  <label htmlFor="profileImage">
                    <img src={image || defaultProfilePic} alt="Profile" />
                  </label>
                  {isHovered && (
                    <div className="hover-icon" onClick={handleImageClick}>
                      <i className="ri-user-add-line"></i>
                    </div>
                  )}
                  <input
                    type="file"
                    id="profileImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </div>
                <div className="profileContent">
                  <div className="typ-header-text">
                    {user?.login_name ||
                      user?.email?.split("@")[0] ||
                      "Username"}
                  </div>
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>Email ID </span>:{" "}
                    {user?.email}
                  </div>
                  <div
                    className="custom-profile-text"
                    onClick={toggleProfileOtpPopup}
                  >
                    Change Password
                  </div>
                </div>
              </div>

              <div className="profileContent">
                <div className="typ-sub-text" style={{ marginTop: 14 }}>
                  <span style={{ fontWeight: 600 }}>User Code</span> :{" "}
                  {cmpUserData?.cmpusercode}
                </div>
              </div>
              <div className="profileContent">
                <div
                  className="typ-sub-text"
                  style={{
                    display: "flex",
                    gap: 2,
                    marginTop: 14,
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Contact Number</span>:
                  {/* VIEW MODE */}
                  {!isEditing && (
                    <>
                      <span>{contactNumber || "-"}</span>

                      <Button
                        icon="edit"
                        stylingMode="text"
                        onClick={() => setIsEditing(true)}
                      />
                    </>
                  )}
                  {/* EDIT MODE */}
                  {isEditing && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <TextBox
                        width={140}
                        value={contactNumber}
                        valueChangeEvent="input"
                        stylingMode="outlined"
                        onValueChanged={(e) => {
                          const value = e.value;

                          //  allow all input (no restriction)
                          setContactNumber(value);

                          //  live validation
                          if (value && !/^\d+$/.test(value)) {
                            setErrors({
                              cmpusercontactnumber: "Only numbers are allowed.",
                            });
                          } else if (
                            value &&
                            (value.length < 3 || value.length > 15)
                          ) {
                            setErrors({
                              cmpusercontactnumber:
                                "Contact Number should be 3 to 15 digits only.",
                            });
                          } else {
                            setErrors({});
                          }
                        }}
                        onFocusOut={() => {
                          const value = contactNumber?.trim();

                          if (!value) {
                            setErrors({
                              cmpusercontactnumber:
                                "Contact Number is Required.",
                            });
                            return;
                          }

                          if (!/^\d+$/.test(value)) {
                            setErrors({
                              cmpusercontactnumber: "Only numbers are allowed.",
                            });
                            return;
                          }

                          if (value.length < 3 || value.length > 15) {
                            setErrors({
                              cmpusercontactnumber:
                                "Contact Number should be 3 to 15 digits only.",
                            });
                            return;
                          }

                          setErrors({});
                          setIsEditing(false);
                        }}
                      />

                      {/*Error Message */}
                      {errors?.cmpusercontactnumber && (
                        <span
                          style={{ color: "red", fontSize: 12, marginTop: 4 }}
                        >
                          {errors.cmpusercontactnumber}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="mainProfileSection">
            <div className="lowerSecProfile">
              <CustomTextBox
                label="Contact Number"
                placeholder="Contact Number"
                value={userPhno}
                onChange={(e) => setUserPhno(e.value)}
                type="text"
              />
            </div>
          </div> */}
          <div className="projectSection">
            <div className="detail-small-light">Assigned Projects</div>
            <div className="lowerSecProfile">
              {assignedProjects?.length > 0 ? (
                assignedProjects.map((category, index) => (
                  <div key={index} className="categoryBlock">
                    <div className="categoryTitle">
                      {category.category_name}
                    </div>

                    <div className="subcategoryList">
                      {category.subcategories.map((sub, subIndex) => (
                        <div key={subIndex} className="subcategoryItem">
                          • {sub.ticketsubcatname}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="detail-mid-light">No Projects Assigned</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomChangePwdPopup
        visible={isProflePopupVisible}
        // onClose={toggleProfileOtpPopup}
        onClose={toggleProfileCloseFromPopup}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  );
}
